module.exports = __webpack_public_path__ + "static/img/kjnyy.5c71d48.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/kjnyy.png
// module id = yvcZ
// module chunks = 0